/**
 * TimingCellDrawer — GA4 매출·트래픽 시점 히트맵의 셀 드릴다운 드로어.
 *
 * 셀(요일 dow × 시간 hour)을 클릭하면, 이미 내려와 있는 TimingDto의 4개 매트릭스
 * (매출/결제/세션/활성사용자)에서 그 버킷 값을 뽑아 KPI로 보여준다. 새 GA4 쿼리 없음.
 */

import { Drawer, StatCard, formatCurrency, formatNumber } from '@/ui'
import type { TimingDto } from '../Analytics'
import styles from './TimingCellDrawer.module.css'

const DAY_LABELS = ['일', '월', '화', '수', '목', '금', '토']

interface TimingCellDrawerProps {
  /** 선택된 셀 — null이면 닫힘 */
  cell: { dow: number; hour: number } | null
  data: TimingDto
  onClose: () => void
}

/** 매트릭스에서 안전하게 셀 값 조회 */
function cellValue(matrix: number[][], dow: number, hour: number): number {
  return matrix[dow]?.[hour] ?? 0
}

export function TimingCellDrawer({ cell, data, onClose }: TimingCellDrawerProps) {
  const title =
    cell != null
      ? `${DAY_LABELS[cell.dow]}요일 ${cell.hour}시 지표`
      : '시점 지표'

  const revenue = cell ? cellValue(data.revenue.matrix, cell.dow, cell.hour) : 0
  const transactions = cell ? cellValue(data.transactions.matrix, cell.dow, cell.hour) : 0
  const sessions = cell ? cellValue(data.sessions.matrix, cell.dow, cell.hour) : 0
  const activeUsers = cell ? cellValue(data.activeUsers.matrix, cell.dow, cell.hour) : 0

  return (
    <Drawer open={cell != null} onClose={onClose} title={title} size="sm">
      <div className={styles.grid}>
        <StatCard label="매출" value={formatCurrency(revenue)} />
        <StatCard label="결제 건수" value={`${formatNumber(transactions)}건`} />
        <StatCard label="세션" value={formatNumber(sessions)} />
        <StatCard label="활성 사용자" value={formatNumber(activeUsers)} />
      </div>
      <p className={styles.caption}>
        GA4 집계 기준 요일×시간 버킷 값입니다. 원본 이벤트 단위 목록은 제공되지 않습니다.
      </p>
    </Drawer>
  )
}
